export default __webpack_public_path__ + "static/media/88c6723521dbef8012cc18059c4fcda61581616987704.3c8ff8fd.webp";